import React, { Component } from 'react'
import moment from 'moment';
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class Collect extends Component {

    DocTimeFormat = (docTime) => {
        let time = (docTime || '').toString();

        if (time.length > 2) {
            let position = time.length - 2;
            time = time.slice(0, position) + ":" + time.slice(position, time.length)
        } else {
            time = `00:${time}`;
        }

        return time;
    }

    render() {
        const {
            ReportsModel,
            DocsToPrint,
            ActualDate,
        } = this.props;

        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE COBRANZA</strong></h5>
                            </div>
                            <div className="col-3">
                                <p>FECHA DOC: {moment(ActualDate).utc().format('MM/DD/YYYY')}<br />Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}
                                    <br />
                                    SUCURSAL: {DocsToPrint[0].currentUser ? DocsToPrint[0].currentUser.Sucursal : 'Sin sucursal'}
                                </p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-12'>
                                <table>
                                    <thead style={{ border: "solid 1px" }}>
                                        <tr>
                                            <th className="text-left pl-3">Folio</th>
                                            <th className="text-left">Cliente</th>
                                            <th className="text-left">Nombre del cliente</th>
                                            <th className="text-center">Fecha</th>
                                            <th className="text-center">Hora</th>
                                            <th className="text-center">Codigo</th>
                                            <th className="text-left">Forma de pago</th>
                                            <th className="text-right  pr-3">Monto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!DocsToPrint[0].ListCollect && DocsToPrint[0].ListCollect.map((collect, index) => {

                                            return (
                                                <tr style={{ fontSize: '12px' }}>
                                                    <td className="text-left pl-3">{collect.folio}</td>
                                                    <td className="text-left">{collect.CardCode}</td>
                                                    <td className="text-left">{collect.CardName}</td>
                                                    <td className="text-center">{moment(collect.datePay).utc().format('MM/DD/YYYY')}</td>
                                                    <td className="text-center">{this.DocTimeFormat(collect.DocTime) + ' HRS'}</td>
                                                    <td className="text-center">{collect.code}</td>
                                                    <td className="text-left">{collect.pm_Name}</td>
                                                    <td className="text-right pr-3">{formatNumber.new(collect.amount)}</td>
                                                </tr>
                                            )

                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default Collect